import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saved-card',
  templateUrl: './saved-card.component.html',
  styleUrls: ['./saved-card.component.css']
})
export class SavedCardComponent implements OnInit {
  isActive: boolean;



  ngOnInit(): void {
    this.isActive = true;
  }

  remove() {
    this.isActive = false;
  }
}
